/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { IComparator } from '../../interface/icomparator';
import { IEntity } from '../../interface/IEntity';
import { Serializable } from '../../engine/db/serializable';
import { NameValue } from '../../tool/name-value';
import { CommonUtils } from '../../tool/common-utils';

export abstract class Entity implements IComparator, IEntity, Serializable {
  lock: boolean;

  abstract getId(): string;

  abstract getLabel(): string;
  /**
   * Serialize a model object to Serialize Entity
   */
  abstract serialize();

  /**
   * Convert an item on instance of Entity
   * @param item : any
   */
  public convert(item): any {
    return item;
  }

  public toString(): string {
    return `${this.getId() ? `${this.getId()} - ` : ''}${this.getLabel()}`;
  }

  public compare(comparant: any, byLabel?: boolean): number {
    if (comparant instanceof Entity) {
      if (byLabel) {
        return CommonUtils.compare(this.getLabel(), comparant.getLabel());
      } else {
        return CommonUtils.compare(this.getId(), comparant.getId());
      }
    } else if (typeof comparant === 'string') {
      if (byLabel) {
        return CommonUtils.compare(this.getLabel(), comparant);
      } else {
        return CommonUtils.compare(this.getId(), comparant);
      }
    } else if (comparant instanceof NameValue) {
      return CommonUtils.compare(this.getId(), comparant.name);
    } else {
      return NaN;
    }
  }

  setId(id: any) {
    void id;
    return;
  }
}
